export const accountTypes = [
  {
    key: 'privateIndividuals',
    icon: 'user',
    img: { src: '/new/account-types/private_individuals.jpg' },
  },
  {
    key: 'municipalities',
    icon: 'bank',
    img: { src: '/new/account-types/municipalities.jpg' },
  },
  {
    key: 'companies',
    icon: 'buildingSkyscraper',
    img: { src: '/new/account-types/companies.jpg' },
  },
  {
    key: 'sportsTeams',
    icon: 'volleyball',
    img: { src: '/new/account-types/sports_teams.jpg' },
  },
  {
    key: 'schoolsKindergartens',
    icon: 'school',
    img: { src: '/new/account-types/schools_and_kindergartens.jpg' },
  },
  {
    key: 'organizations',
    icon: 'users',
    img: { src: '/new/account-types/organizations.jpg' },
  },
];
